import { Box, CardMedia, Typography } from "@mui/material";
import EthiquinNoData from "../../../../../assets/images/Ethiquin/ethiquin_no_data.svg";

// Estado vacío reutilizable con el Ethiquin: imagen centrada + título + acción opcional.
export const EthiquinEmptyState = ({
  title,
  action,
  height = "50vh",
  imageWidth = { xs: "70%", md: 320 },
}) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height,
    }}
  >
    <CardMedia
      src={EthiquinNoData}
      component="img"
      alt="No data"
      sx={{
        width: imageWidth,
        height: "auto",
        mx: "auto",
        my: 2,
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        WebkitTouchCallout: "none",
        WebkitUserDrag: "none",
        opacity: 0.85,
      }}
    />
    {title && (
      <Typography textAlign="center" variant="h5" my={2}>
        {title}
      </Typography>
    )}
    {action}
  </Box>
);
